/**
 * Export Jurisdiction and Classification U.S. EAR99, India Not Subject to Regulations
 */

import { configureStore } from '@reduxjs/toolkit'
import loginReducer from './loginSlice';
import reRenderReducer from './reRenderSlice';
import userRoleReducer from './userRolesSlice';
import watchNavigationReducer from './watchNavigationSlice';

export const store = configureStore({
  reducer: {
    login: loginReducer,
    reRender:reRenderReducer,
    userRole:userRoleReducer,
    watchNavigation:watchNavigationReducer
  },
  middleware:(getDefaultMiddleware) => getDefaultMiddleware({
    serializableCheck: false
  })
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch